import {AMOUNT_DISPLAY_OVERCHARGED} from '../reducers/flights/FlightsReducer';

export default class MarkupHelper {
    static shouldHideOvercharge(amountDisplay, agencySettings) {
        return !!parseInt(agencySettings['1b1a9800d2ac8edf3964760d1f496acb']) || (amountDisplay === AMOUNT_DISPLAY_OVERCHARGED);
    }
}



// WEBPACK FOOTER //
// ./src/helpers/MarkupHelper.js